<template>
  <div>
    <EditarReciboComponent
      v-if="reciboSelected"
      :recibo_id="reciboSelected.id"
      @guardado="volver()"
    ></EditarReciboComponent>
    <div class="app-main__inner" v-else>
      <TituloComponente icono-titulo="fas fa-plus" texto-titulo="Nueva liquidación" />
      <div class="tab-content">
        <div
          class="tab-pane tabs-animation fade show active"
          id="tab-content-0"
          role="tabpanel"
        >
          <div class="row">
            <div class="col-lg-12">
              <div class="main-card mb-3 card">
                <div class="card-body">
                  <div class="row justify-content-center">
                    <h4 class="text-center mb-3 col-12">Período</h4>
                    <float-label label="MES:" clase="col-md-3">
                      <select id="mes" class="form-control" v-model="mes">
                        <option v-for="m in meses" :value="m" :key="m">
                          {{ m }}
                        </option>
                      </select>
                    </float-label>
                    <float-label label="AÑO:" clase="col-md-3">
                      <select id="año" class="form-control" v-model="año">
                        <option v-for="n in años" :key="n" :value="n">
                          {{ n }}
                        </option>
                      </select>
                    </float-label>
                    <div class="w-100"></div>
                    <float-label label="TIPO:" clase="col-md-3">
                      <select id="tipo" class="form-control" v-model="tipo_liquidacion">
                        <option value="null">Seleccione tipo</option>
                        <option
                          v-for="tipo in tipos_liquidacion"
                          :key="tipo.id"
                          :value="tipo.descripcion"
                        >
                          {{ tipo.descripcion }}
                        </option>
                      </select>
                    </float-label>
                    <float-label label="Fecha de pago:" clase="col-md-3">
                      <input
                        type="date"
                        value=""
                        v-model="fecha_pago"
                        class="form-control"
                      />
                    </float-label>
                    <div class="w-100"></div>
                    <h5 class="text-center col-12">Per. Dep</h5>
                    <float-label label="MES:" clase="col-md-3">
                      <select id="mes" class="form-control" v-model="mes_per_dep">
                        <option v-for="m in meses" :value="m" :key="m">
                          {{ m }}
                        </option>
                      </select>
                    </float-label>
                    <float-label label="AÑO:" clase="col-md-3">
                      <select id="año" class="form-control" v-model="año_per_dep">
                        <option v-for="n in años" :key="n" :value="n">
                          {{ n }}
                        </option>
                      </select>
                    </float-label>
                    <div class="w-100"></div>
                    <file-select class="col-md-6" v-model="file"></file-select>
                  </div>
                </div>
              </div>
              <div v-if="preview">
                <div class="main-card mb-3 card">
                  <div class="card-header">
                    <ul class="nav nav-justified">
                      <li
                        class="nav-item"
                        v-for="(totales, seccion, n) in preview"
                        :key="n"
                      >
                        <a
                          data-toggle="tab"
                          :href="'#' + seccion.replace(/[ ]|[.]|/g, '')"
                          class="nav-link active show"
                          v-if="n == 0"
                          >{{ seccion }}</a
                        >
                        <a
                          data-toggle="tab"
                          :href="'#' + seccion.replace(/[ ]|[.]|/g, '')"
                          class="nav-link"
                          v-else
                          >{{ seccion }}</a
                        >
                      </li>
                    </ul>
                  </div>
                  <div class="card-body">
                    <div class="tab-content">
                      <h5 class="text-focus font-weight-bold col-md-10">
                        Resumen archivo:
                      </h5>
                      <div
                        class="col-12 offset-md-2 col-md-8 row tab-pane show"
                        :class="n == 0 ? 'active' : ''"
                        :id="seccion.replace(/[ ]|[.]|/g, '')"
                        role="tabpanel"
                        v-for="(totales, seccion, n) in preview"
                        :key="n"
                      >
                        <div class="col-12">
                          <h4 class="text-focus font-weight-bold">
                            {{ seccion }}
                          </h4>
                          <div
                            class="row"
                            v-for="(monto, concepto, n) in totales.conceptos"
                            :key="n"
                          >
                            <template v-if="monto.total > 0">
                              <div class="col-8">
                                <b class="text-secondary">{{ concepto }}:</b>
                              </div>
                              <div class="col-4">
                                <span class="font-weight-bold text-success"
                                  >$ {{ monto.total | numFormat("0,0.00") }}</span
                                >
                              </div>
                            </template>
                          </div>
                          <br />
                          <div class="row">
                            <div class="col-8">
                              <b class>Haberes remunerativos:</b>
                            </div>
                            <div class="col-4">
                              <span class="font-weight-bold text-primary"
                                >${{
                                  totales.total_remunerativo | numFormat("0,0.00")
                                }}</span
                              >
                            </div>
                            <div class="col-8">
                              <b class>Haberes no remunerativos:</b>
                            </div>
                            <div class="col-4">
                              <span class="font-weight-bold text-primary"
                                >${{
                                  totales.total_no_remunerativo | numFormat("0,0.00")
                                }}</span
                              >
                            </div>
                            <div class="col-8">
                              <b class>Deducciones:</b>
                            </div>
                            <div class="col-4">
                              <span class="font-weight-bold text-primary"
                                >${{ totales.retenciones | numFormat("0,0.00") }}</span
                              >
                            </div>
                            <hr />
                            <div class="col-8">
                              <h5 class="text-primary">
                                <b>Total liquidado:</b>
                              </h5>
                            </div>
                            <div class="col-4">
                              <span class="font-weight-bold text-danger"
                                >${{
                                  totales.total_liquidado | numFormat("0,0.00")
                                }}</span
                              >
                            </div>
                          </div>
                        </div>
                        <hr class="w-100" />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="main-card mb-3 card">
                  <div class="card-body">
                    <h5 class="text-focus font-weight-bold col-md-10">
                      Listado de recibos
                    </h5>
                    <div class="row col-md-10">
                      <div class="col-md-6 col-12 form-group input-group">
                        <input
                          type="text"
                          class="form-control form-control-sm"
                          placeholder="Buscar.."
                          v-model="params.search"
                        />
                        <span class="input-group-append">
                          <button type="button" class="btn btn-sm btn-primary">
                            <i class="fas fa-search"></i>
                          </button>
                        </span>
                      </div>
                    </div>
                    <div
                      class="row col-md-12 pt-3 pt-3"
                      style="max-height: 500px; overflow-y: auto"
                    >
                      <div class="col-lg-12">
                        <div class="mb-3 col-12">
                          <div class="row">
                            <ul class="list-group list-group-flush mb-3" v-if="searching">
                              <li class="list-group-item">
                                <div class="skeleton">
                                  <div class="skeleton-author"></div>
                                  <div class="skeleton-content"></div>
                                  <div class="skeleton-content"></div>
                                </div>
                              </li>
                              <li class="list-group-item">
                                <div class="skeleton">
                                  <div class="skeleton-author"></div>
                                  <div class="skeleton-content"></div>
                                  <div class="skeleton-content"></div>
                                </div>
                              </li>
                            </ul>
                            <ul
                              class="list-group list-group-flush mb-3"
                              v-else-if="recibos == 0"
                            >
                              <li class="list-group-item">
                                <h5 class="text-center">No se encontraron resultados</h5>
                              </li>
                            </ul>
                            <ul class="list-group list-group-flush mb-3 col-12" v-else>
                              <li
                                class="list-group-item hoverable"
                                v-for="(recibo, i) in recibosFiltrados"
                                :key="i"
                                @click="verRecibo(recibo)"
                              >
                                <div class="widget-content p-0">
                                  <div class="widget-content-wrapper row">
                                    <div class="widget-content-left col-12">
                                      <h5 class="widget-heading">
                                        <span class="text-primary">
                                          <span>{{ recibo.nombre }}</span>
                                        </span>
                                      </h5>
                                      <div class="widget-subheading opacity-10 row">
                                        <span class="col-sm-auto col-12 row">
                                          <span class="text-left col-sm-auto col-12">
                                            Legajo N°
                                            <b class="text-alternate">{{
                                              recibo.numero_legajo
                                            }}</b>
                                          </span>
                                          <span class="text-left col-sm-auto col-12">
                                            <b class="text-alternate"
                                              >{{ recibo.per_dep }} -
                                              {{ recibo.mensual_jornal }}</b
                                            >
                                          </span>
                                          <span class="text-left col-sm-auto col-12">
                                            Seccion:
                                            <b class="text-alternate">{{
                                              recibo.seccion
                                            }}</b>
                                          </span>
                                          <span
                                            class="ml-lg-3 text-left col-sm-auto col-12"
                                          >
                                            Neto:
                                            <b class="text-alternate">
                                              $ {{ recibo.neto | numFormat("0,0.00") }}</b
                                            >
                                          </span>
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-2 mt-2 mb-4 float-right">
                <button
                  class="btn btn-info btn-block"
                  type="button"
                  @click="cerrarLiquidacion"
                >
                  Guardar
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import TituloComponente from "@/components/layouts/TituloComponente";
import FloatLabel from "@/components/layouts/FloatLabel";
import FileSelect from "@/components/layouts/FileSelect";
import XLSX from "xlsx";
import axios from "axios";
import Swal from "sweetalert2";
import EditarReciboComponent from "@/components/views/recibo/EditarReciboComponent";
export default {
  name: "NuevaLiquidacion",
  components: {
    TituloComponente,
    FloatLabel,
    FileSelect,
    EditarReciboComponent,
  },
  data() {
    return {
      recibos: [],
      searching: false,
      fecha: new Date(),
      mes: "",
      año: null,
      mes_per_dep: "",
      año_per_dep: null,
      tipo_liquidacion: null,
      fecha_pago: null,
      tipos_liquidacion: [],
      file: null,
      conceptos: [],
      legajos: [],
      preview: null,
      sin_legajos: [],
      loading: false,
      reciboSelected: null,
      params: {
        search: "",
        liquidacion_id: null,
      },
    };
  },
  computed: {
    recibosFiltrados: function () {
      if (this.recibos) {
        let filtro = [...this.recibos];
        filtro.sort(function (a, b) {
          if (a.nombre > b.nombre) {
            return 1;
          }
          if (a.nombre < b.nombre) {
            return -1;
          }
          // a must be equal to b
          return 0;
        });
        if (this.params.search == "") {
          return filtro;
        }
        return filtro.filter(
          function (item) {
            return item.nombre.toUpperCase().includes(this.params.search.toUpperCase());
          }.bind(this)
        );
      }
      return [];
    },
    años: function () {
      let array = [];
      for (let index = 2018; index <= 2035; index++) {
        array.push(index);
      }
      return array;
    },
    meses: function () {
      return [
        "ENERO",
        "FEBRERO",
        "MARZO",
        "ABRIL",
        "MAYO",
        "JUNIO",
        "JULIO",
        "AGOSTO",
        "SEPTIEMBRE",
        "OCTUBRE",
        "NOVIEMBRE",
        "DICIEMBRE",
      ];
    },
  },
  watch: {
    file: function (file) {
      if (file != null) {
        this.leerExcel();
      }
    },
  },
  mounted() {
    this.año = this.$moment(this.fecha).format("YYYY");
    this.mes = this.$moment(this.fecha).format("MMMM").toUpperCase();
    this.año_per_dep = this.$moment(this.fecha).format("YYYY");
    this.mes_per_dep = this.$moment(this.fecha).format("MMMM").toUpperCase();
    this.loading = true;
    this.getTipoLiquidacion();
    axios
      .get("nuevaliquidacion")
      .then((res) => {
        this.legajos = res.data.legajos;
        this.conceptos = res.data.conceptos;
      })
      .finally(() => {
        this.loading = false;
      });
  },
  methods: {
    leerExcel() {
      let reader = new FileReader();
      let $this = this;
      this.loading = true;
      reader.onload = function () {
        this.loading = true;
        let arraybuffer = this.result;
        /* convert data to binary string */
        let data = new Uint8Array(arraybuffer);
        let arr = new Array();

        for (let i = 0; i != data.length; ++i) arr[i] = String.fromCharCode(data[i]);
        let bstr = arr.join("");

        /* Call XLSX */
        let workbook = XLSX.read(bstr, { type: "binary" });
        /* DO SOMETHING WITH workbook HERE */
        let first_sheet_name = workbook.SheetNames[0];
        /* Get worksheet */
        let worksheet = workbook.Sheets[first_sheet_name];

        let filas = XLSX.utils.sheet_to_json(worksheet, {
          raw: true,
          blankrows: true,
          defval: "-",
          header: 1,
        });
        for (let fila of filas) {
          let array = fila;
          let recibo = {};
          if (!isNaN(array[0])) {
            let legajo = $this.legajos.find((legajo) => legajo.numero == array[0]);
            if (legajo != null) {
              recibo.legajo_id = legajo.id;
              recibo.numero = parseInt(array[0]);
              recibo.fecha_ingreso = parseInt(array[1]);
              recibo.numero_afiliado = parseInt(array[2]);
              if (!legajo.seccion) {
                Swal.fire({
                  icon: "error",
                  title: "Error",
                  text: `No se encuentra la sección para el legajo ${legajo.numero}.`,
                });
              }
              recibo.seccion = legajo.seccion.descripcion;
              recibo.año = !isNaN(array[3]) ? parseInt(array[3]) : 0;
              recibo.mes = !isNaN(array[4]) ? parseInt(array[4]) : 0;
              recibo.conceptos = [];
              let concepto = {};
              for (let i in array) {
                if (i > 4 && !isNaN(array[i])) {
                  if (i % 2 > 0 && array[i]) {
                    console.log($this.conceptos)
                    console.log(array[i])
                    let c = $this.conceptos.find(
                      (concepto) => {
                        let itemArray = array[i]
                        if(typeof(itemArray) === 'string'){
                          itemArray = itemArray.trim()
                        }
                        return concepto.codigo ==  parseInt(itemArray)
                      }
                    );
                    if (c == null) {
                      Swal.fire({
                        icon: "error",
                        title: "Error",
                        text: `El codigo de conepto ${array[i]} no se corresponde con ningún concepto de la institución.`,
                      });
                    }
                    concepto.codigo = array[i];
                    concepto.descripcion = c.descripcion;
                    concepto.tipo = c.tipo;
                  } else {
                    if ("codigo" in concepto) {
                      concepto.valor = parseFloat(array[i].toFixed(2));
                      recibo.conceptos.push(concepto);
                    }
                    concepto = {};
                  }
                }
              }
              $this.recibos.push(recibo);
            } else {
              Swal.fire({
                icon: "error",
                title: "Error",
                text: `El legajo N° ${array[0]} no se corresponde con ningún legajo de la institución.`,
              });
              recibo.numero = array[0];
              recibo.año = array[1];
              recibo.mes = array[2];
              recibo.conceptos = [];
              let concepto = {};
              for (let i in array) {
                if (i > 2 && !isNaN(array[i])) {
                  if (i % 2 > 0) {
                    concepto.codigo = array[i];
                  } else {
                    if (array[i] > 0) {
                      concepto.valor = array[i];
                      recibo.conceptos.push(concepto);
                      concepto = {};
                    } else {
                      concepto = {};
                    }
                  }
                }
              }
              $this.sin_legajos.push(recibo);
            }
            console.log(recibo);
          }
        }
        $this.vista_previa($this.recibos);
        $this.loading = false;
        $this.guardar();
      };
      reader.readAsArrayBuffer(this.file);
    },
    guardar() {
      axios
        .post("liquidacion", {
          recibos: this.recibos,
          institucion: this.$store.state.institucion,
          periodo: this.mes + " " + this.año,
          per_dep: this.mes_per_dep + " " + this.año_per_dep,
          tipo_liquidacion: this.tipo_liquidacion,
        })
        .then((res) => {
          if (res.data.success) {
            this.recibos = res.data.liquidacion.recibos;
            this.params.liquidacion_id = res.data.liquidacion.id;
          }
        })
        .catch((e) => {
          Swal.fire({
            icon: "error",
            title: "Error",
            html: `<p>No se pudo cargar con éxito la liquidacion</p><p>${e.response.data.message}</p>`,
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    cerrarLiquidacion() {
      if (this.tipo_liquidacion == null) {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: `Debe seleccionar el tipo de liquidación`,
        });
        return false;
      }
      if (this.fecha_pago == null) {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: `Debe seleccionar la fecha de cobro`,
        });
        return false;
      }
      if (this.recibos.length == 0) {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: `Debe cargar recibos.`,
        });
        return false;
      }
      Swal.fire({
        title: "¿Estás seguro que deseas guardar la liquidación?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Guardar",
        cancelButtonText: "Cancelar",
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          axios
            .put("liquidacion/" + this.params.liquidacion_id, {
              periodo: this.mes + " " + this.año,
              per_dep: this.mes_per_dep + " " + this.año_per_dep,
              tipo_liquidacion: this.tipo_liquidacion,
              fecha_pago: this.fecha_pago,
            })
            .then((res) => {
              if (res.data.success) {
                Swal.fire({
                  icon: "success",
                  title: "Éxito",
                  text: `La liquidación se guardó con éxito.`,
                });
                this.$router.push({ name: "ListarLiquidaciones" });
              }
            })
            .finally(() => {
              this.loading = false;
            });
        }
      });
    },
    vista_previa(recibos) {
      this.preview = {};
      for (let recibo of recibos) {
        if (this.preview[recibo.seccion] === undefined) {
          let seccion = {};
          seccion.total_remunerativo = 0;
          seccion.total_no_remunerativo = 0;
          seccion.total_haberes = 0;
          seccion.total_liquidado = 0;
          seccion.legajos = 0;
          seccion.retenciones = 0;
          seccion.conceptos = {};
          this.preview[recibo.seccion] = seccion;
        }
        this.preview[recibo.seccion].legajos += 1;
        for (let item of recibo.conceptos) {
          if (item.tipo == "Remunerativo") {
            this.preview[recibo.seccion].total_remunerativo += item.valor;
            this.preview[recibo.seccion].total_haberes += item.valor;
          } else if (
            item.tipo == "No remunerativo" ||
            item.tipo == "Asignación familiar"
          ) {
            this.preview[recibo.seccion].total_no_remunerativo += item.valor;
            this.preview[recibo.seccion].total_haberes += item.valor;
          } else if (item.tipo == "Retención") {
            this.preview[recibo.seccion].retenciones += item.valor;
          }
          if (this.preview[recibo.seccion].conceptos[item.descripcion] === undefined) {
            this.preview[recibo.seccion].conceptos[item.descripcion] = {};
            this.preview[recibo.seccion].conceptos[item.descripcion].total = 0;
          }
          this.preview[recibo.seccion].conceptos[item.descripcion].total += item.valor;
        }

        this.preview[recibo.seccion].total_liquidado =
          this.preview[recibo.seccion].total_haberes -
          this.preview[recibo.seccion].retenciones;
      }
    },
    getTipoLiquidacion() {
      axios.get("tipoliquidacion").then((res) => {
        this.tipos_liquidacion = res.data;
      });
    },

    verRecibo(recibo) {
      Swal.fire({
        title: `¿Deseas editar el recibo de ${recibo.nombre}?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Editar",
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (result) {
          this.reciboSelected = recibo;
        }
      });
    },
    volver() {
      this.reciboSelected = null;
      this.getRecibos();
    },
    getRecibos() {
      this.loading = true;
      this.params.search = "";
      axios
        .get("recibo/", { params: this.params })
        .then((res) => {
          if (res.data.success) {
            this.recibos = res.data.recibo;
          }
        })
        .catch(() => {
          Swal.fire({
            icon: "warning",
            title: "Oopss..",
            text: `No se ha encontrado Recibos.`,
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    leerAtras() {
      if (window.location.hash) {
        this.reciboSelected = null;
      }
    },
  },
};
</script>
